var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtnIcon07On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2512 23.6385H12.748C11.6641 23.6385 10.8125 22.7789 10.8125 21.6849V9.37719C10.8125 8.28317 11.6641 7.42358 12.748 7.42358H19.2512C20.3351 7.42358 21.1867 8.28317 21.1867 9.37719V21.6849C21.1867 22.7398 20.2964 23.6385 19.2512 23.6385Z",
    stroke: "#25426D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7104 10.4712H13.291V13.9877H18.7104V10.4712Z",
    stroke: "#25426D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31V1.6383C23.81 1.22528 20.1433 1 16.1833 1C12.0767 1 8.26333 1.30038 5 1.75094V31H27Z",
    stroke: "#25426D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 20.7082C17.0689 20.7082 17.9354 19.8336 17.9354 18.7546C17.9354 17.6757 17.0689 16.801 15.9999 16.801C14.931 16.801 14.0645 17.6757 14.0645 18.7546C14.0645 19.8336 14.931 20.7082 15.9999 20.7082Z",
    stroke: "#25426D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnIcon07On);
export default __webpack_public_path__ + "static/media/btn_icon07_on.c74f40e2f764346dbac44a90dd49adcc.svg";
export { ForwardRef as ReactComponent };